export const termConfig = {
    "3": {
        months: [
            { value: "1", removable: false },
            { value: "2", removable: false },
            { value: "3", removable: false },
        ],
    },

    "6": {
        months: [
            { value: "1", removable: false },
            { value: "2", removable: true },
            { value: "3", removable: false },
            { value: "4", removable: true },
            { value: "6", removable: false },
        ],
    },
    "7": {
        months: [
            { value: "1", removable: false },
            { value: "2", removable: true },
            { value: "3", removable: false },
            { value: "6", removable: true },
            { value: "7", removable: false },
        ],
    },
    "9": {
        months: [
            { value: "1", removable: false },
            { value: "3", removable: true },
            { value: "4", removable: false },
            { value: "7", removable: true },
            { value: "9", removable: false },
        ],
    },
    "11": {
        months: [
            { value: "1", removable: false },
            { value: "3", removable: true },
            { value: "6", removable: false },
            { value: "9", removable: true },
            { value: "11", removable: false },
        ],
    },
    "12": {
        months: [
            { value: "1", removable: false },
            { value: "3", removable: true },
            { value: "6", removable: false },
            { value: "9", removable: true },
            { value: "12", removable: false },
        ],
    },
    "13": {
        months: [
            { value: "1", removable: false },
            { value: "3", removable: true },
            { value: "6", removable: false },
            { value: "12", removable: true },
            { value: "13", removable: false },
        ],
    },
    "15": {
        months: [
            { value: "1", removable: false },
            { value: "3", removable: true },
            { value: "6", removable: false },
            { value: "12", removable: true },
            { value: "15", removable: false },
        ],
    },
    "18": {
        months: [
            { value: "1", removable: false },
            { value: "3", removable: true },
            { value: "9", removable: false },
            { value: "15", removable: true },
            { value: "18", removable: false },
        ],
    },
    "19": {
        months: [
            { value: "1", removable: false },
            { value: "6", removable: true },
            { value: "12", removable: false },
            { value: "18", removable: true },
            { value: "19", removable: false },
        ],
    },
    "22": {
        months: [
            { value: "1", removable: false },
            { value: "6", removable: true },
            { value: "12", removable: false },
            { value: "18", removable: true },
            { value: "22", removable: false },
        ],
    },
    "24": {
        months: [
            { value: "1", removable: false },
            { value: "6", removable: true },
            { value: "12", removable: false },
            { value: "18", removable: true },
            { value: "24", removable: false },
        ],
    },
    "25": {
        months: [
            { value: "1", removable: false },
            { value: "6", removable: true },
            { value: "12", removable: false },
            { value: "21", removable: true },
            { value: "25", removable: false },
        ],
    },
    "30": {
        months: [
            { value: "1", removable: false },
            { value: "6", removable: true },
            { value: "12", removable: false },
            { value: "24", removable: true },
            { value: "30", removable: false },
        ],
    },
    "36": {
        months: [
            { value: "1", removable: false },
            { value: "6", removable: true },
            { value: "18", removable: false },
            { value: "24", removable: true },
            { value: "36", removable: false },
        ],
    },
    "48": {
        months: [
            { value: "1", removable: false },
            { value: "12", removable: true },
            { value: "24", removable: false },
            { value: "36", removable: true },
            { value: "48", removable: false },
        ],
    },
    "60": {
        months: [
            { value: "1", removable: false },
            { value: "24", removable: true },
            { value: "36", removable: false },
            { value: "48", removable: true },
            { value: "60", removable: false },
        ],
    },
};

export const usdFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

export const BLUE_CREDITONE = 'rgba(10, 94, 192, 1)';
export const GREEN_SILVER_TREE = 'rgba(91, 188, 129, 1)';
export const BLUE_ONAHAU = 'rgba(206, 230, 255, 1)';